import React from 'react'
import { CardSeeker, IconSeeker } from '@ui-seeker/core'

import RealTimeTableErrorsDataTemplate from 'Pages/RealTimeHistory/RealTime/ErrorData/Template'
import { Box, Typography, useTheme } from '@mui/material'
import { isEmpty } from '@ui-seeker/utils'


export default function RealTimeTableErrorsData({ tableDataErrors }) {

	const { palette } = useTheme()

	return <CardSeeker title="ERROR" sx={{ mb: 2 }} contentProps={{ sx: { pt: 0 } }}>

		{!isEmpty(tableDataErrors.badConfigData || {}) && <RealTimeTableErrorsDataTemplate
			title={<Box sx={{ display: "flex", alignItems: "center", justifyContent: "start", gap: 1 }}>
				<IconSeeker icon="rotate-exclamation" sx={{ color: "success.dark", fontSize: "1rem", }}/>
				<Typography variant="h6">Bad config</Typography>
			</Box>}
			data={tableDataErrors.badConfigData} color={palette.success.main}/>}

		{!isEmpty(tableDataErrors.errorData || {}) &&
			<RealTimeTableErrorsDataTemplate title={<Box sx={{ display: "flex", alignItems: "center", justifyContent: "start", gap: 1 }}>
				<IconSeeker icon="circle-exclamation" sx={{ color: "error.main", fontSize: "1rem", }}/>
				<Typography variant="h6">Error data</Typography>
			</Box>} data={tableDataErrors.errorData} color={palette.error.main}/>}

		{!isEmpty(tableDataErrors.noAvailData || {}) &&
			<RealTimeTableErrorsDataTemplate title={<Box sx={{ display: "flex", alignItems: "center", justifyContent: "start", gap: 1 }}>
				<IconSeeker icon="triangle-exclamation" sx={{ color: "warning.main", fontSize: "1rem", }}/>
				<Typography variant="h6">Not available</Typography>
			</Box>} data={tableDataErrors.noAvailData} color={palette.warning.main}/>}
	</CardSeeker>
}